/**
 * The web app's public Keycloak client. Kept free of imports (no `@/env`)
 * so the Node-run E2E auth contract can share it — captured sessions and
 * token exchanges must target the client the app authenticates against.
 */
export const KEYCLOAK_CLIENT_ID = "eport";
